import { SortingParams } from 'src/app/interfaces/connections.interface';
import {
  CommentPosition,
  CommentView,
  FullRootCommentView,
  LoadedCommentsState,
} from 'src/app/interfaces/posts.interface';

export abstract class CommentSortingStrategyService {
  public sortRootComments(rootComments: FullRootCommentView[]): FullRootCommentView[] {
    const comments: FullRootCommentView[] = structuredClone(rootComments);

    return comments.sort((a: FullRootCommentView, b: FullRootCommentView) =>
      this.sortingByDate(a.rootCommentView, b.rootCommentView),
    );
  }

  public sortReplies(replyCommentViews: CommentView[]): CommentView[] {
    const replies: CommentView[] = structuredClone(replyCommentViews);

    return replies.sort((a: CommentView, b: CommentView) => this.sortingByDate(a, b));
  }

  public abstract getSortingParams(): SortingParams;

  public abstract addNewRootComment(
    loadedComments: LoadedCommentsState,
    newRootComment: FullRootCommentView,
  ): LoadedCommentsState;

  public abstract addNewReply(
    loadedComments: LoadedCommentsState,
    repliedCommentPosition: CommentPosition,
    replyCommentView: CommentView,
  ): LoadedCommentsState;

  protected abstract sortingByDate(a: CommentView, b: CommentView): number;
}
